/* eslint-disable jsx-a11y/alt-text */
import { useAuth0 } from "@auth0/auth0-react";
import { Text } from "components";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import MyModal from "components/MyModal";
import MemberService from "Lib/API/Member";
import UserService from "Lib/API/users/index";
import React from "react";
import { toastr } from "react-redux-toastr";
import AddNewUser from "../../AddNewUser";
import InvitationModal from "../../InvitationModal/InvitationModal";
import MemberTable from "../../MemberTables/memberTable";
const FamilyTable = ({
  mainContactId,
  setRefresh,
  refresh,
  member,
  setFamilyMember,
  familyMember,
}) => {
  const [memberToRemove, setMemberToRemove] = React.useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [openAddModel, setOpenAddModel] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openInvitationModel, setOpenInvitationModel] = React.useState(false);
  const [currentContact, setCurrentContact] = React.useState({});
  const [confirmClose, setConfirmClose] = React.useState(false);
 const [disableMemberUSerModal, setDisableMemberUserModal] = React.useState({
    open: false,
    data: {},
    loading: false,
  });

  const handleDelete = async () => {
    if (mainContactId === memberToRemove) {
      setOpen(false);
      return;
    }

    const token = await getAccessTokenSilently();
    await MemberService.removeContact({ contactID: memberToRemove }, token)
      .then((res) => {
        if (res) {
          setOpen(false);
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        setOpen(false);
        toastr.error("Error", err?.data?.message);
      });
  };


  const openInvitationModelHandler = (dataRow) => {
    setOpenInvitationModel(true);
    setCurrentContact(dataRow)
  }

  const openDisableMemberUserHandler = (dataRow) => {
    setDisableMemberUserModal((prev) => ({
      ...prev,
      open: true,
      data: dataRow,
    }));
  }

  const closeDisableMemberUserHandler = () => {
    setDisableMemberUserModal((prev) => ({
      ...prev,
      open: false,
      data: {},
    }));
  }

  const disableMemberUserHandler = async () => {
    setDisableMemberUserModal((prev) => ({
      ...prev,
      loading: true,
    }));
    const token = await getAccessTokenSilently();
    await UserService.disableMemberUser({token, contactId: disableMemberUSerModal?.data?._id})
    .then((res) => {
      closeDisableMemberUserHandler();
      refreshData();
      toastr.success("Success", "Member disabled successfully");
    })
    .catch((error) => {
      toastr.error("Error", error?.data?.message ?? "Something Went Wrong");
    }).finally(() => {
      setDisableMemberUserModal((prev) => ({
        ...prev,
        loading: false,
      }));
    })
  }

  const refreshData = () => {
    setRefresh(!refresh);
  };

  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenAddModel(false);
  }



  return (
    <div className="family-table-container">
      <div className="my-auto page-header">
        <Text className="sub-title">Family Members</Text>
          <Button
            variant="primary"
            onClick={() => setOpenAddModel(true)}
            style={{ marginRight: "3rem" }}
          >
            <span>Add new family member</span>
          </Button>

      </div>
      <div
        className="home-table-container mt-0"
        style={{
          marginBottom: "4rem !important",
        }}
      >
        <MemberTable
          family_members={member?.family_members}
          member={member}
          setRefresh={setRefresh}
          refresh={refresh}
          setFamilyMember={setFamilyMember}
          openAddModel={openAddModel}
          openInvitationModelHandler={openInvitationModelHandler}
          openDisableMemberUserHandler={openDisableMemberUserHandler}
        />
      </div>
      <AlertDialog
        open={open}
        handleClose={() => setOpen(false)}
        onDecline={() => setOpen(false)}
        onAccept={handleDelete}
        title={"Are you sure?"}
      />
      <MyModal
        className="invite-modal"
        open={openAddModel}
        onClose={closeModal}
      >
        <AddNewUser
          setOpen={setOpenAddModel}
          account_id={member?._id}
          setRefresh={setRefresh}
          refresh={refresh}
          setFamilyMember={setFamilyMember}
          familyMember={familyMember}
        />
      </MyModal>
      <MyModal
        className="invite-people-modal"
        open={openInvitationModel}
        onClose={() => {
          setOpenInvitationModel(false);
        }}
      >
        <InvitationModal 
          closeModal={() => setOpenInvitationModel(false)}
          contactId={currentContact?._id}
          defaultEmail={currentContact?.email_address}
          refreshData={refreshData}
        />
      </MyModal>
      <AlertDialog
        open={disableMemberUSerModal.open}
        onDecline={closeDisableMemberUserHandler}
        onAccept={disableMemberUserHandler}
        title={"Are you sure?"}
        description={"Do you want to disable this member?"}
        disabled={disableMemberUSerModal.loading}

      />
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};

export default FamilyTable;
